import React from 'react';
import { Helmet } from 'react-helmet-async';
import type { Selector } from 'react-redux';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';

const AlternateLinks: React.FC = () => {
  const alternateLinks = useSelector(
    select.cms.getAlternateLinks as Selector<
      RootState,
      ReturnType<typeof select.cms.getAlternateLinks>
    >
  );

  return (
    <Helmet>
      {alternateLinks.map(({ localeCode, url }) => (
        <link key={localeCode} rel="alternate" hrefLang={localeCode} href={url} />
      ))}
    </Helmet>
  );
};

export default AlternateLinks;
